// extracted by mini-css-extract-plugin
module.exports = {"example":"FooterExample_example__3Lp-1"};